<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HjPBbv/tc-custom/9781913682484.jpg?1737676321434" alt="This image is the cover for the book Candles and Roses, The DI Alec McKay Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Candles and Roses, The DI Alec McKay Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In this gritty crime thriller set in the Scottish Highlands, a detective’s hunt for a serial killer leads him to confront his own past.</b></p><p>Haunted by the loss of his daughter, Detective Inspector Alec McKay obsesses over a missing person case that’s going nowhere. But that investigation is interrupted when bodies start appearing on the Scottish Black Isle—each with roses and candles placed around it. As McKay and his team begin to identify a disturbing pattern behind the killings, the killer’s twisted intentions remain allusive.<br/><br/> Meanwhile, the young woman who discovered the first victim has begun an investigation of her own—one that catches McKay’s attention, and possibly the killer’s as well. As the case unfolds, McKay is forced to face his own demons. Now, to catch the killer, McKay must untangle a nightmarish web of truth and lies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alex Walters
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1fabf331